export const extractEmailsFromString = (value: string): string[] => {
  const regex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi
  const emails = value.match(regex)

  return emails || []
}
